var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflowBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66927 13.3307L6.00261 13.3307L6.00261 9.9974L2.66927 9.9974L2.66927 13.3307ZM6.00261 14.6641C6.73899 14.6641 7.33594 14.0671 7.33594 13.3307L7.33594 9.9974C7.33594 9.26102 6.73899 8.66406 6.00261 8.66406L2.66927 8.66406C1.93289 8.66406 1.33594 9.26102 1.33594 9.9974L1.33594 13.3307C1.33594 14.0671 1.93289 14.6641 2.66927 14.6641L6.00261 14.6641ZM6.00261 5.9974L2.66927 5.9974L2.66927 2.66406L6.00261 2.66406L6.00261 5.9974ZM7.33594 5.9974C7.33594 6.73378 6.73899 7.33073 6.00261 7.33073L2.66927 7.33073C1.93289 7.33073 1.33594 6.73378 1.33594 5.9974L1.33594 2.66406C1.33594 1.92768 1.93289 1.33073 2.66927 1.33073L6.00261 1.33073C6.73899 1.33073 7.33594 1.92768 7.33594 2.66406L7.33594 5.9974Z",
    fill: "#7898FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L14 2L14 3.33333L8 3.33333L8 2Z",
    fill: "#7898FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33333L14 5.33333L14 6.66667L8 6.66667L8 5.33333Z",
    fill: "#7898FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33333L14 9.33333L14 10.6667L8 10.6667L8 9.33333Z",
    fill: "#7898FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6667L14 12.6667L14 14L8 14L8 12.6667Z",
    fill: "#7898FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowBlue);
export default __webpack_public_path__ + "static/media/workflow-blue.a2af4fee870770ee7f7e29e3a92d2178.svg";
export { ForwardRef as ReactComponent };